<div class="alert-modal-container">
  <div class="close-icon ion-padding" (click)="closeModal()" style="display: flex;">
    <img class="arrow ion-padding" src="../../../../assets/images/right-arrow.svg" alt="">&nbsp;&nbsp;
    <p>Continue to itiamc.com</p>
  </div>
  <div class="message-container">
    <div class="message-text content-web-section" [ngClass]="flag ? 'pan-adhaar-desktop' : 'nomination-updation-desktop'" (click)="redirectTo(flag)">
    </div>
    <div class="message-text content-mobile-section" [ngClass]="flag ? 'pan-adhaar-mobile' : 'nomination-updation-mobile'" (click)="redirectTo(flag)"></div>
  </div>
</div>